import angular from 'angular';
import ColorPaletteConstant from './color-palette.constant';

const ColorPaletteModule = angular
    .module('control-room.commons.basic.constant.color-palette', [])
    .constant('crColorPaletteConstant', ColorPaletteConstant);

export default ColorPaletteModule;
